import Flickity from 'flickity';

const initSponsorsCarousels = (elements) => {
    elements.forEach(el => {
        const flickityOptions = {
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            lazyLoad: true,
            imagesLoaded: true,
            watchCSS: true
        };

        const carousel = new Flickity(el, flickityOptions);
    })
}

export default initSponsorsCarousels;